import React, { useEffect, useState } from 'react';
import { textFilter } from 'react-bootstrap-table2-filter';
import { VscNewFile, VscRefresh, VscSearch } from 'react-icons/vsc';
import { useDispatch, useSelector } from 'react-redux';
import AttenteRequete from '../../../hoc/AttenteRequete/AttenteRequete';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import * as privilege from '../../../ressources/glossaires/glossaire_privileges';
import * as requestType from '../../../ressources/glossaires/glossaire_requetes';
import * as type_btn from '../../../ressources/glossaires/glossaire_type_de_bouton';
import * as actions from '../../../services/actions';
import Bouton from '../../UI/Bouton/Bouton';
import Tableau from '../../UI/tableau/Tableau';

const TableauVue = (props) => {
  const interfaceAdmin = useSelector(
    (state) => state.authentifie.interfaceAdmin
  );
  const listeVues = useSelector((state) => state.vue.views_list);
  const filtre_projects_list_id = useSelector(
    (state) => state.authentifie.filtre_projects_list_id
  );
  const project_id_url = useSelector(
    (state) => state.interfaceClient.project_id_url
  );
  const dispatch = useDispatch();

  // State for columns
  const [columns, setColumns] = useState([
    {
      dataField: 'view_id',
      text: [
        checkMot('id'),
        <Bouton
          key="search-view-id"
          type={type_btn.lupeSearch}
          cliquer={() => afficherFiltre('view_id', checkMot('id'))}
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
    {
      dataField: 'project_id',
      text: [
        checkMot('id_projet'),
        <Bouton
          key="search-project-id"
          type={type_btn.lupeSearch}
          cliquer={() => afficherFiltre('project_id', checkMot('id_projet'))}
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
    {
      dataField: 'view_name',
      text: [
        checkMot('nom'),
        <Bouton
          key="search-view-name"
          type={type_btn.lupeSearch}
          cliquer={() => afficherFiltre('view_name', checkMot('nom'))}
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
    {
      dataField: 'view_title',
      text: [
        checkMot('descriptif'),
        <Bouton
          key="search-view-title"
          type={type_btn.lupeSearch}
          cliquer={() => afficherFiltre('view_title', checkMot('descriptif'))}
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
  ]);

  // State for selectRow configuration
  const [selectRow] = useState({
    mode: 'radio',
    clickToSelect: true,
    hideSelectAll: true,
    hideSelectColumn: true,
    style: () => {
      return {
        background: '#eeb214',
        color: 'black',
      };
    },
    onSelect: (row) => {
      return props.projetSelectione(row);
    },
  });

  const iconeCreer = <VscNewFile size={15} />;
  const recupererListeVues = (projectIds) => {
    dispatch(actions.reqRecupererListeVues(projectIds));
  };

  useEffect(() => {
    if (project_id_url !== undefined && project_id_url !== '') {
      recupererListeVues([parseInt(project_id_url)]);
    } else if (filtre_projects_list_id.length > 0) {
      recupererListeVues(filtre_projects_list_id);
    }
  }, []);

  useEffect(() => {
    if (!isNaN(project_id_url) && project_id_url !== '') {
      recupererListeVues([parseInt(project_id_url)]);
    }
  }, [project_id_url]);

  useEffect(() => {
    recupererListeVues(filtre_projects_list_id);
  }, [filtre_projects_list_id]);

  const afficherFiltre = (dataField, placeholder) => {
    const newCol = columns.map((col) => {
      if (col.dataField === dataField) {
        return {
          ...col,
          filter: textFilter({
            placeholder: placeholder,
          }),
        };
      } else {
        return col;
      }
    });
    setColumns(newCol);
  };

  // Calculate rows to hide  let listeCleACache = [];
  if (listeVues !== undefined) {
    if (interfaceAdmin) {
      for (let indLigne = 0; indLigne < listeVues.length; indLigne++) {
        if (
          filtre_projects_list_id.indexOf(
            parseInt(listeVues[indLigne].project_id)
          ) < 0
        ) {
          props.listeCleACache?.push(listeVues[indLigne].view_id);
        }
      }
    } else {
      for (let indLigne = 0; indLigne < listeVues.length; indLigne++) {
        if (
          parseInt(listeVues[indLigne].project_id) !== parseInt(project_id_url)
        ) {
          props.listeCleACache?.push(listeVues[indLigne].view_id);
        }
      }
    }
  }

  return (
    <>
      <Tableau
        cleLigne={'view_id'}
        privilegeCreer={privilege.creer_des_vues}
        creer={props.creer}
        iconeCreer={iconeCreer}
        donnees={listeVues}
        colonnes={columns}
        selectionnerLignes={selectRow}
        lignesCache={props.listeCleACache}
      >
        <AttenteRequete
          request_type={requestType.recuperation_de_la_liste_des_vues}
          str={checkMot('maj_vues_en_cour')}
        >
          <Bouton
            hoverText={checkMot('refresh')}
            type={type_btn.outil}
            rond={true}
            cliquer={() => {
              recupererListeVues(filtre_projects_list_id);
            }}
          >
            <VscRefresh size={15} />
          </Bouton>
        </AttenteRequete>
      </Tableau>
    </>
  );
};

export default TableauVue;
